import { FC, HTMLAttributes } from 'react';
import clsx from 'clsx';

import Alert from '@/assets/icons/Alert';
import Check from '@/assets/icons/Check';
import Info from '@/assets/icons/Info';
import WarningTriangleOrange from '@/assets/icons/WarningTriangleOrange';

import styles from './Notification.module.css';

const NotificationIcons = {
  warning: <WarningTriangleOrange aria-hidden='true' />,
  error: <Alert fill='var(--tractie-color-content-error)' aria-hidden='true' />,
  info: <Info fill='var(--tractie-color-content-info)' aria-hidden='true' />,
  success: <Check fill='var(--tractie-color-content-success)' aria-hidden='true' />,
};

type NotificationVariant = 'warning' | 'error' | 'info' | 'success';
type IconAlignment = 'flex-start' | 'center';
type NotificationPropsType = HTMLAttributes<HTMLDivElement> & {
  variant?: NotificationVariant;
  iconAlignment?: IconAlignment;
};

const Notification: FC<NotificationPropsType> = ({
  children,
  variant = 'warning',
  iconAlignment = 'center',
  className,
  ...divProps
}) => {
  return (
    <div
      data-testid={`notification-${variant}`}
      {...divProps}
      className={clsx(styles.notificationStyle, styles[`notificationVariantStyle--${variant}`], className)}
      style={{ display: 'flex', alignItems: iconAlignment }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>{NotificationIcons[variant]}</div>
      <div>{children}</div>
    </div>
  );
};

export default Notification;
